import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import MUIDataTable from 'mui-datatables';
import { IconButton, Icon } from '@material-ui/core';
import { TextFormattedNumber } from 'components';
import { addTasksToQueueApi, deleteQuoteProductSubscriptionOptionApi } from 'api';
import { useStyles } from '../Subscriptions/styles';


const MembershipOptionsTable = ({ setEditableMembership }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { editableQuoteProduct, quoteProductSubscriptionOptions } = useSelector(
    (state: IReduxState) => state.quote
  );

  const {
    profile: { stores },
  } = useSelector((state: IReduxState) => state.user);
  const [{ quoteProStoreCode }] = stores;

  const deleteMembershipOption = async (id) => {
    if (quoteProductSubscriptionOptions.length === 1) {
      const productToUpdate = {
        sku: editableQuoteProduct?.sku,
        custom_attributes: [
          { attribute_code: 'subscription_active', value: 0 },
        ],
      };
      const task = {
        body: productToUpdate,
        name: editableQuoteProduct?.name,
        sku: editableQuoteProduct?.sku,
        requestType: 'UPDATE_PRODUCT',
        storeViewCode: quoteProStoreCode,
      };
      addTasksToQueueApi({ dispatch, tasks: [task] });
    }

    await deleteQuoteProductSubscriptionOptionApi({ dispatch, id });
  };

  const columns = [
    {
      name: 'frequency',
      label: 'Frequency',
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          const { frequency_unit, frequency_count } =
            quoteProductSubscriptionOptions[dataIndex];

          return (
            <div className="flex items-center">
              {frequency_count != 0
                ? `Every${
                  frequency_count == 1 ? '' : ` ${frequency_count}`
                } ${frequency_unit}${frequency_count > 1 ? 's' : ''}`
                : 'One Time Purchase'}
            </div>
          );
        },
      },
    },
    {
      name: 'installment_price',
      label: 'Recurring Price',
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: (dataIndex) => (
          <div className="flex items-center">
            <TextFormattedNumber
              value={
                quoteProductSubscriptionOptions[dataIndex]?.installment_price
              }
              prefix="$"
            />
          </div>
        ),
      },
    },
    {
      name: 'first_period_price',
      label: 'First Period Price',
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          const { adjustment_price, installment_price } = quoteProductSubscriptionOptions[dataIndex];

          if (adjustment_price === null && installment_price === null) {
            return null;
          }

          const first_period_price = (adjustment_price || 0) + (installment_price || 0);

          return (
            <div className="flex items-center">
              <TextFormattedNumber
                value={first_period_price}
                prefix="$"
              />
            </div>
          );
        },
      },
    },
    {
      name: 'sproduct_label',
      label: 'Product Label',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'ssort_order',
      label: 'Sort Order',
      options: {
        display: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          const { ssort_order } = quoteProductSubscriptionOptions[dataIndex];

          return (
            <div className="flex items-center px-7">{ssort_order}</div>
          );
        }
      }
    },
    {
      name: 'action',
      label: 'Actions',
      options: {
        sort: false,
        filter: false,
        setCellHeaderProps: () => ({ style: { width: '150px' } }),
        customBodyRenderLite: (dataIndex) => {
          const { frequency_count, id } =
            quoteProductSubscriptionOptions[dataIndex];

          return (
            <>
              {frequency_count != 0 && (
                <div className="flex items-left">
                  <IconButton
                    className="mr-3 p-2"
                    title="Edit"
                    size="small"
                    onClick={() =>
                      setEditableMembership(
                        quoteProductSubscriptionOptions[dataIndex]
                      )
                    }
                  >
                    <Icon fontSize="small">edit</Icon>
                  </IconButton>
                  <IconButton
                    className="mr-3 p-2"
                    title="Delete"
                    size="small"
                    onClick={() => deleteMembershipOption(id)}
                  >
                    <Icon fontSize="small">delete</Icon>
                  </IconButton>
                </div>
              )}
            </>
          );
        },
      },
    },
  ];

  return (
    <>
      {!!quoteProductSubscriptionOptions.length && (
        <MUIDataTable
          className={`m-3 ${classes.root}`}
          data={quoteProductSubscriptionOptions}
          columns={columns}
          options={{
            elevation: 0,
            filter: false,
            selectableRows: 'none',
            download: false,
            print: false,
            search: false,
            pagination: false,
            viewColumns: false,
            sortOrder: {
              name: 'ssort_order',
              direction: 'asc',
            },
          }}
        />
      )}
    </>
  );
};

export default MembershipOptionsTable;
